<button class="volver-arriba-govco position-fixed" aria-label="Volver arriba">
  <span class="govco-expand_circle_up"></span>
</button>

<div class="portales-pie-pagina-govco" *ngIf="footerInfo?.data">
  <div class="first-section">
    <div class="first-logo-section">
      <div>
        <span class="govco-logo-potencia"></span>
      </div>
      <div>
        <img
         [src]="entidadJustifacil.logoMiniUrl"
          alt="Logo Justicia" height="88" />
      </div>
    </div>
    <div class="second-logo-section">
      <div>
        <span class="govco-logo"></span>
      </div>
      <div>
        <span class="govco-co"></span>
      </div>
    </div>
  </div>

  <div class="second-third-section">
    <div class="second-section">
      <h5 *ngIf="entidadJustifacil.entidad">{{ entidadJustifacil.entidad }}</h5>

      <ul class="contact-data-container">
        <li>
          <p>
            {{ 'footer.direccion' | translate }}
            {{ footerInfo?.data?.data?.address }}
          </p>
        </li>
        <li>
          <p>
            {{ 'footer.codigo' | translate }} {{ footerInfo?.data?.data?.zip }}
          </p>
        </li>
        <li>
          <p>
            {{ 'footer.horario' | translate }} {{ footerInfo?.data?.data?.time }}
          </p>
        </li>
      </ul>

      <div class="links-container">
        <a
          *ngIf="footerInfo?.data?.redes?.x"
          [href]="footerInfo?.data?.redes?.x?.path"
          role="button"
          class="btn-govco fill-link-btn-govco"
          style="width: 160px; height: 33px"
          aria-label="Enlace al Twitter de la entidad">
          <span class="govco-svg govco-twitter" aria-hidden="true"></span>
          <span>{{ footerInfo?.data?.redes?.x?.user }}</span>
        </a>

        <a
          *ngIf="footerInfo?.data?.redes?.instagram"
          [href]="footerInfo?.data?.redes?.instagram?.path"
          role="button"
          class="btn-govco fill-link-btn-govco"
          style="width: 160px; height: 33px"
          aria-label="Enlace al Instagram de la entidad">
          <span class="govco-svg govco-instagram" aria-hidden="true"></span>
          <span>{{ footerInfo?.data?.redes?.instagram?.user }}</span>
        </a>

        <a
          *ngIf="footerInfo?.data?.redes?.facebook"
          [href]="footerInfo?.data?.redes?.facebook?.path"
          role="button"
          class="btn-govco fill-link-btn-govco"
          style="width: 160px; height: 33px"
          aria-label="Enlace al Facebook de la entidad">
          <span class="govco-svg govco-facebook-f" aria-hidden="true"></span>
          <span>{{ footerInfo?.data?.redes?.facebook?.user }}</span>
        </a>
      </div>
    </div>

    <div class="third-section">
      <h5>
        <span class="govco-icon govco-phone-alt"></span>
        {{ 'footer.contacto' | translate }}
      </h5>

      <ul class="contact-data-container">
        <li>
          <p>
            {{ 'footer.telefono' | translate }} {{ footerInfo?.data?.data?.phone }}
          </p>
        </li>
        <li>
          <p>
            {{ 'footer.linea-gratuita' | translate }} {{ footerInfo?.data?.data?.freeLine }}
          </p>
        </li>
        <li>
          <p>
            {{ 'footer.linea-anticorrupcion' | translate }} {{ footerInfo?.data?.data?.anticorrup }}
          </p>
        </li>
        <li>
          <p>
            {{ 'footer.correo' | translate }}
            <a
              *ngIf="footerInfo?.data?.data?.emailInsti"
              [href]="'mailto:' + footerInfo?.data?.data?.emailInsti"
              class="btn-govco fill-link-btn-govco"
              aria-label="Permite enviar correo"
              target="_blank">
              {{ footerInfo?.data?.data?.emailInsti }}
            </a>
          </p>
        </li>
      </ul>

      <div class="end-links-container">
        <a
          *ngIf="footerInfo?.data?.legal?.policies"
          [href]="footerInfo?.data?.legal?.policies"
          class="btn-govco fill-link-btn-govco">
          {{ 'footer.politicas' | translate }}
        </a>
        <a
          *ngIf="footerInfo?.data?.legal?.sitemaps"
          [href]="footerInfo?.data?.legal?.sitemaps"
          class="btn-govco fill-link-btn-govco">
          {{ 'footer.mapa' | translate }}
        </a>
        <a
          *ngIf="footerInfo?.data?.legal?.terms"
          [href]="footerInfo?.data?.legal?.terms"
          class="btn-govco fill-link-btn-govco">
          {{ 'footer.terminos' | translate }}
        </a>
        <a
          *ngIf="footerInfo?.data?.legal?.acces"
          [href]="footerInfo?.data?.legal?.acces"
          class="btn-govco fill-link-btn-govco">
          {{ 'footer.accesibilidad' | translate }}
        </a>

        <p>Version 0.29.33.0</p>
      </div>
    </div>
  </div>
</div>
